package com.zq.webproject.ui.home

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.navigationBars
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBars
import androidx.compose.foundation.layout.systemBars
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Star
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Snackbar
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshotFlow
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import coil3.compose.AsyncImage
import coil3.compose.rememberAsyncImagePainter
import com.zq.webproject.model.Product
import com.zq.webproject.network.model.Banner
import com.zq.webproject.network.model.Category
import com.zq.webproject.ui.about.AboutScreen
import com.zq.webproject.ui.bankcard.AddBankCardScreen
import com.zq.webproject.ui.earnings.EarningsRecordScreen
import com.zq.webproject.ui.invite.InviteScreen
import com.zq.webproject.ui.invite.InvitedUsersScreen
import com.zq.webproject.ui.order.OrderDetailScreen
import com.zq.webproject.ui.payment.PaymentSuccessScreen
import com.zq.webproject.ui.productdetail.ProductDetailScreen
import com.zq.webproject.ui.profile.ProfileScreen
import com.zq.webproject.ui.purchaserecord.PurchaseRecordScreen
import com.zq.webproject.ui.resources.ResourceInfoScreen
import com.zq.webproject.ui.ranking.RankingBanner
import com.zq.webproject.ui.ranking.RankingScreen
import com.zq.webproject.ui.recharge.RechargeScreen
import com.zq.webproject.ui.upload.UploadProductScreen
import com.zq.webproject.ui.withdraw.WithdrawRecordScreen
import com.zq.webproject.ui.withdraw.WithdrawScreen
import com.zq.webproject.utils.getCurrentTimeMillis
import com.zq.webproject.utils.ObserveAppLifecycle
import com.zq.webproject.utils.TokenManager
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
// 移除kotlinx.datetime依赖，改用kotlin.system API
// import kotlinx.datetime.Clock
// import kotlinx.datetime.TimeZone
// import kotlinx.datetime.toLocalDateTime
import org.jetbrains.compose.resources.Font
import webproject.composeapp.generated.resources.Res
import webproject.composeapp.generated.resources.font_song

// 统一字体（使用宋体，包含完整中文字符）
private val CaiFont: FontFamily
    @Composable
    get() = FontFamily(Font(Res.font.font_song))

/**
 * 默认占位图/错误图URL
 */
private const val DEFAULT_IMAGE = "https://image.aiotzq.com/agi0.png"

/**
 * 图片URL处理工具函数
 * 统一为所有图片URL添加基础路径
 */
private fun getFullImageUrl(imageUrl: String?): String {
    // 默认图片
    val defaultImage = "agi0.png"

    if (imageUrl.isNullOrEmpty()) {
        println("getFullImageUrl - 图片URL为空,使用默认图片: $defaultImage") // 日志输出
        val baseImageUrl = "https://image.aiotzq.com/"
        val fullUrl = baseImageUrl + defaultImage
        println("getFullImageUrl - 默认图片完整路径: $fullUrl") // 日志输出
        return fullUrl
    }

    // 如果已经包含完整的http/https路径,直接返回
    if (imageUrl.startsWith("http://") || imageUrl.startsWith("https://")) {
        println("getFullImageUrl - 图片URL已是完整路径: $imageUrl") // 日志输出
        return imageUrl
    }

    // 拼接基础路径
    val baseImageUrl = "https://image.aiotzq.com/"
    val fullUrl = baseImageUrl + imageUrl
    println("getFullImageUrl - 拼接图片URL: $imageUrl -> $fullUrl") // 日志输出
    return fullUrl
}

/**
 * 电商首页
 */
@Composable
fun ECommerceHomeScreen(
    viewModel: HomeViewModel = remember { HomeViewModel() }
) {
    val uiState = viewModel.uiState
    val selectedCategoryId = viewModel.selectedCategoryId
    val isLoggedIn = viewModel.isLoggedIn
    val currentUser = viewModel.currentUser
    val currentUserRole = viewModel.currentUserRole  // 获取用户角色
    val showLoginDialog = viewModel.showLoginDialog
    val showProfileScreen = viewModel.showProfileScreen
    val showProductDetail = viewModel.showProductDetail
    val currentProductId = viewModel.currentProductId
    val showOrderDetail = viewModel.showOrderDetail
    val currentOrderNo = viewModel.currentOrderNo
    val showPaymentSuccess = viewModel.showPaymentSuccess
    val paymentSuccessOrderNo = viewModel.paymentSuccessOrderNo
    val paymentSuccessAmount = viewModel.paymentSuccessAmount
    val paymentSuccessPaymentMethod = viewModel.paymentSuccessPaymentMethod


    val showInviteScreen = viewModel.showInviteScreen
    val showInvitedUsersScreen = viewModel.showInvitedUsersScreen
    val showPurchaseRecordScreen = viewModel.showPurchaseRecordScreen
    val showWithdrawScreen = viewModel.showWithdrawScreen
    val showAddBankCardScreen = viewModel.showAddBankCardScreen
    val showWithdrawRecordScreen = viewModel.showWithdrawRecordScreen
    val showEarningsRecordScreen = viewModel.showEarningsRecordScreen
    val showRankingScreen = viewModel.showRankingScreen
    val showAboutScreen = viewModel.showAboutScreen
    val showUploadProductScreen = viewModel.showUploadProductScreen  // 上传商品页面
    val showResourceInfo = viewModel.showResourceInfo
    val resourceProduct = viewModel.resourceProduct

    // 判断是否在首页（所有其他页面都没有显示）
    val isOnHomePage = !showAboutScreen && !showRankingScreen && !showEarningsRecordScreen &&
            !showWithdrawRecordScreen && !showAddBankCardScreen && viewModel.showRechargeScreen.not() &&
            !showWithdrawScreen && !showPurchaseRecordScreen && !showInvitedUsersScreen &&
            !showInviteScreen && !showPaymentSuccess && !showOrderDetail && !showProductDetail &&
            !showProfileScreen && !showUploadProductScreen  // 添加上传商品页面判断

    // 监听页面返回首页，刷新数据并检查用户角色
    LaunchedEffect(isOnHomePage) {
        if (isOnHomePage && isLoggedIn) {
            println("ECommerceHomeScreen - 返回首页，刷新数据并检查用户角色")
            viewModel.refreshHomeData()
        }
    }

    // 监听 App 生命周期（从后台切换到前台时检查用户角色）
    ObserveAppLifecycle(
        onResume = {
            viewModel.onAppResumed()
        }
    )

    // 页面销毁时清理资源
    DisposableEffect(Unit) {
        onDispose {
            viewModel.onCleared()
        }
    }

    Box(modifier = Modifier.fillMaxSize()) {
        // 显示上传商品页面
        if (showUploadProductScreen) {
            UploadProductScreen(
                onBackClick = {
                    println("ECommerceHomeScreen - 上传商品页面返回")
                    viewModel.closeUploadProduct()
                }
            )
        }
        // 显示关于页面
        else if (showAboutScreen) {
            AboutScreen(
                onBackClick = {
                    println("ECommerceHomeScreen - 关于页面返回到我的页面")
                    viewModel.closeAbout()  // 关闭关于页面
                    viewModel.openProfile()  // 打开我的页面
                }
            )
        }
        // 显示排行榜页面
        else if (showRankingScreen) {
            RankingScreen(
                onBackClick = {
                    println("ECommerceHomeScreen - 排行榜页面返回到首页")
                    viewModel.closeRanking()  // 关闭排行榜页面
                }
            )
        }
        // 显示收益记录页面
        else if (showEarningsRecordScreen) {
            EarningsRecordScreen(
                onBackClick = {
                    println("ECommerceHomeScreen - 收益记录页面返回到我的页面")
                    viewModel.closeEarningsRecord()  // 关闭收益记录页面
                    viewModel.openProfile()          // 打开我的页面
                }
            )
        }
        // 显示提现记录页面
        else if (showWithdrawRecordScreen) {
            WithdrawRecordScreen(
                onBackClick = {
                    println("ECommerceHomeScreen - 提现记录页面返回到提现页面")
                    viewModel.closeWithdrawRecord()  // 关闭提现记录页面
                    // 提现页面会自动显示，因为showWithdrawScreen仍然为true
                }
            )
        }
        // 显示添加银行卡页面
        else if (showAddBankCardScreen) {
            AddBankCardScreen(
                onBackClick = {
                    println("ECommerceHomeScreen - 添加银行卡页面返回到提现页面")
                    viewModel.closeAddBankCard()  // 关闭添加银行卡页面
                    // 提现页面会自动显示，因为showWithdrawScreen仍然为true
                },
                onAddSuccess = {
                    println("ECommerceHomeScreen - 银行卡添加成功，返回提现页面")
                    viewModel.closeAddBankCard()  // 关闭添加银行卡页面
                    // 提现页面会自动显示，因为showWithdrawScreen仍然为true
                }
            )
        }
        // 显示充值页面
        else if (viewModel.showRechargeScreen) {
            RechargeScreen(
                onBackClick = {
                    println("ECommerceHomeScreen - 充值页面返回到我的页面")
                    viewModel.closeRecharge()  // 关闭充值页面
                    viewModel.openProfile()    // 打开我的页面
                }
            )
        }
        // 显示提现页面
        else if (showWithdrawScreen) {
            WithdrawScreen(
                balance = null,  // WithdrawViewModel会自动加载余额，这里传null
                onBackClick = {
                    println("ECommerceHomeScreen - 提现页面返回到我的页面")
                    viewModel.closeWithdraw()   // 关闭提现页面
                    viewModel.openProfile()     // 打开我的页面
                },
                onAddBankCardClick = {
                    println("ECommerceHomeScreen - 点击添加银行卡按钮，打开添加银行卡页面")
                    viewModel.openAddBankCard()  // 打开添加银行卡页面
                },
                onWithdrawRecordClick = {
                    println("ECommerceHomeScreen - 点击提现记录按钮，打开提现记录页面")
                    viewModel.openWithdrawRecord()  // 打开提现记录页面
                }
            )
        }
        // 显示购买记录页面
        else if (showPurchaseRecordScreen) {
            PurchaseRecordScreen(
                onBackClick = {
                    println("ECommerceHomeScreen - 购买记录页面返回到我的页面")
                    viewModel.closePurchaseRecord()  // 关闭购买记录页面
                    viewModel.openProfile()          // 打开我的页面
                },
                onOrderClick = { orderNo ->
                    println("ECommerceHomeScreen - 点击订单记录，准备跳转到订单详情: $orderNo") // 日志输出
                    viewModel.closePurchaseRecord()    // 关闭购买记录页面
                    viewModel.openOrderDetail(orderNo) // 打开订单详情页面
                }
            )
        }
        // 显示邀请用户列表页面
        else if (showInvitedUsersScreen) {
            InvitedUsersScreen(
                onBackClick = {
                    println("ECommerceHomeScreen - 邀请用户列表页面返回到我的页面")
                    viewModel.closeInvitedUsers()  // 关闭邀请用户列表页面
                    viewModel.openProfile()        // 打开我的页面
                }
            )
        }
        // 显示邀请页面
        else if (showInviteScreen) {
            InviteScreen(
                onBackClick = {
                    println("ECommerceHomeScreen - 邀请页面返回到我的页面")
                    viewModel.closeInvite()  // 关闭邀请页面
                    viewModel.openProfile()  // 打开我的页面
                }
            )
        }
        // 显示支付成功页面（最高优先级）
        else if (showPaymentSuccess && paymentSuccessOrderNo != null && paymentSuccessAmount != null) {
            PaymentSuccessScreen(
                orderNo = paymentSuccessOrderNo,
                amount = paymentSuccessAmount,
                paymentMethod = paymentSuccessPaymentMethod ?: "balance",  // 支付方式
                resourceUrl = viewModel.paymentSuccessResourceUrl,  // 传递资源链接
                onBackToHome = {
                    println("ECommerceHomeScreen - 支付成功页面返回首页") // 日志输出
                    viewModel.closePaymentSuccess()
                }
            )
        }
        // 显示订单详情页面
        else if (showOrderDetail && currentOrderNo != null) {
            OrderDetailScreen(
                orderNo = currentOrderNo,
                onBackClick = { viewModel.closeOrderDetail() },
                onPaymentSuccess = { orderNo, amount, paymentMethod, resourceUrl ->
                    println("ECommerceHomeScreen - 支付成功，准备跳转到支付成功页面: orderNo=$orderNo, amount=$amount, paymentMethod=$paymentMethod, resourceUrl=$resourceUrl") // 日志输出
                    viewModel.openPaymentSuccess(orderNo, amount, paymentMethod, resourceUrl)
                }
            )
        }
        // 显示商品详情页面
        else if (showProductDetail && currentProductId != null) {
            ProductDetailScreen(
                productId = currentProductId,
                onBackClick = { viewModel.closeProductDetail() },
                onOrderCreated = { orderNo ->
                    println("ECommerceHomeScreen - 订单创建成功，准备跳转: $orderNo") // 日志输出
                    if (orderNo == "UPGRADE_ADMIN_SUCCESS") {
                        // 特殊处理：升级管理员成功，跳转到支付成功页面
                        println("ECommerceHomeScreen - 升级管理员成功，跳转到支付成功页面") // 日志输出
                        viewModel.closeProductDetail()  // 关闭商品详情页
                        viewModel.openPaymentSuccess("", 0.0, "", "") // 打开支付成功页面，使用空值
                    } else {
                        // 普通订单，跳转到订单详情页
                        viewModel.closeProductDetail()  // 关闭商品详情页
                        viewModel.openOrderDetail(orderNo)  // 打开订单详情页
                    }
                },
                onLoginRequired = {
                    println("ECommerceHomeScreen - 商品详情页需要登录，返回首页并打开登录弹框") // 日志输出
                    viewModel.closeProductDetail()  // 关闭商品详情页
                    viewModel.showLogin()           // 打开登录弹框
                },
                onShowResourceInfo = { productId ->
                    println("ECommerceHomeScreen - 点击显示资源信息，商品ID: $productId") // 日志输出
                    // 先关闭商品详情页
                    viewModel.closeProductDetail()
                    // 始终通过API获取完整的商品详情（包含 image3 字段）
                    println("ECommerceHomeScreen - 通过API获取商品详情，商品ID: $productId") // 日志输出
                    viewModel.fetchProductDetailForResource(productId) { product ->
                        if (product != null) {
                            println("ECommerceHomeScreen - 获取商品详情成功，打开资源信息页面") // 日志输出
                            viewModel.openResourceInfo(product)
                        } else {
                            println("ECommerceHomeScreen - 无法获取商品详情，商品可能不存在") // 日志输出
                        }
                    }
                }
            )
        }
        // 显示资源信息页面
        else if (showResourceInfo && resourceProduct.value != null) {
            ResourceInfoScreen(
                product = resourceProduct.value!!,  // 从 State 中获取实际的 Product 对象
                onBackClick = { viewModel.closeResourceInfo() }
            )
        }
        // 显示我的页面
        else if (showProfileScreen) {
            ProfileScreen(
                username = currentUser,
                onBackClick = { viewModel.closeProfile() },
                onLogout = {
                    println("ECommerceHomeScreen - 用户退出登录，清除Token并返回首页")
                    viewModel.logout()  // 调用ViewModel的退出登录方法
                },
                onInviteClick = {
                    println("ECommerceHomeScreen - 点击邀请按钮，打开邀请页面")
                    viewModel.closeProfile()  // 关闭我的页面
                    viewModel.openInvite()    // 打开邀请页面
                },
                onInvitedUsersClick = {
                    println("ECommerceHomeScreen - 点击我的邀请按钮，打开邀请用户列表页面")
                    viewModel.closeProfile()      // 关闭我的页面
                    viewModel.openInvitedUsers()  // 打开邀请用户列表页面
                },
                onPurchaseRecordClick = {
                    println("ECommerceHomeScreen - 点击购买记录按钮，打开购买记录页面")
                    viewModel.closeProfile()        // 关闭我的页面
                    viewModel.openPurchaseRecord()  // 打开购买记录页面
                },
                onWithdrawClick = {
                    println("ECommerceHomeScreen - 点击提现按钮，打开提现页面")
                    viewModel.closeProfile()    // 关闭我的页面
                    viewModel.openWithdraw()    // 打开提现页面
                },
                onRechargeClick = {
                    println("ECommerceHomeScreen - 点击充值按钮，打开充值页面")
                    viewModel.closeProfile()    // 关闭我的页面
                    viewModel.openRecharge()    // 打开充值页面
                },
                onEarningsRecordClick = {
                    println("ECommerceHomeScreen - 点击收益记录按钮，打开收益记录页面")
                    viewModel.closeProfile()         // 关闭我的页面
                    viewModel.openEarningsRecord()   // 打开收益记录页面
                },
                onRankingClick = {
                    println("ECommerceHomeScreen - 点击排行榜按钮，打开排行榜页面")
                    viewModel.closeProfile()  // 关闭我的页面
                    viewModel.openRanking()   // 打开排行榜页面
                },
                onAboutClick = {
                    println("ECommerceHomeScreen - 点击关于按钮，打开关于页面")
                    viewModel.closeProfile()  // 关闭我的页面
                    viewModel.openAbout()     // 打开关于页面
                },
                onUploadProductClick = {
                    println("ECommerceHomeScreen - 点击上传商品按钮，打开上传商品页面")
                    viewModel.closeProfile()        // 关闭我的页面
                    viewModel.openUploadProduct()   // 打开上传商品页面
                }
            )
        }
        // 显示首页
        else {
            // 显示首页
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color(0xFFF5F5F5))
            ) {
                // 1. 固定在顶部的标题栏（包含登录按钮）
                println("ECommerceHomeScreen - 渲染顶部标题栏") // 日志输出
                TopBar(
                    modifier = Modifier.windowInsetsPadding(WindowInsets.statusBars),
                    isLoggedIn = isLoggedIn,
                    username = currentUser,
                    onProfileClick = { viewModel.openProfile() }
                )

                // 2. 固定在顶部的分类导航栏
                if (uiState.categories.isNotEmpty()) {
                    println("ECommerceHomeScreen - 渲染分类导航栏，分类数量: ${uiState.categories.size}") // 日志输出
                    TopCategoryNav(
                        categories = uiState.categories,
                        selectedCategoryId = selectedCategoryId,
                        onCategoryClick = { viewModel.selectCategory(it) }
                    )
                } else if (!uiState.isLoading) {
                    // 无需登录就能查看
                    EmptyPlaceholder(message = "暂无商品分类")
                }

                // 3. 可滚动的内容区域（Banner + 商品列表） - 使用LazyColumn实现上拉加载下拉刷新
                println("ECommerceHomeScreen - 渲染可滚动内容区域") // 日志输出

                val listState = rememberLazyListState()
                val coroutineScope = rememberCoroutineScope()
                val isRefreshing = viewModel.isRefreshing
                val isLoadingMore = viewModel.isLoadingMore

                // 下拉刷新相关状态
                var pullOffset by remember { mutableStateOf(0f) }
                var isDragging by remember { mutableStateOf(false) }
                val refreshThreshold = 50f // 触发刷新的阈值（像素）- 降低阈值
                val dragResistance = 0.3f // 拖动阻力系数，越小越费力

                // 监测滚动到底部，触发加载更多
                LaunchedEffect(listState) {
                    snapshotFlow {
                        val layoutInfo = listState.layoutInfo
                        val totalItems = layoutInfo.totalItemsCount
                        val lastVisibleItem = layoutInfo.visibleItemsInfo.lastOrNull()?.index ?: 0

                        // 当滚动到倒数3个项目时开始加载
                        lastVisibleItem >= totalItems - 3 && totalItems > 0
                    }.collect { shouldLoadMore ->
                        if (shouldLoadMore && !isLoadingMore && !isRefreshing) {
                            viewModel.loadMore()
                        }
                    }
                }

                // 刷新完成后重置偏移
                LaunchedEffect(isRefreshing) {
                    if (!isRefreshing && pullOffset > 0) {
                        // 平滑回弹到初始位置
                        while (pullOffset > 0) {
                            pullOffset = (pullOffset - 10f).coerceAtLeast(0f)
                            delay(16) // 约60fps
                        }
                    }
                }

                Box(modifier = Modifier.fillMaxSize()) {
                    // 下拉刷新指示器（固定在顶部，随 pullOffset 显示）
                    if (pullOffset > 0 || isRefreshing) {
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .offset(y = (pullOffset - 60).coerceAtLeast(0f).dp)
                                .padding(vertical = 8.dp),
                            contentAlignment = Alignment.Center
                        ) {
                            Surface(
                                shape = RoundedCornerShape(20.dp),
                                color = Color.White,
                                shadowElevation = 4.dp
                            ) {
                                Row(
                                    modifier = Modifier.padding(horizontal = 16.dp, vertical = 8.dp),
                                    horizontalArrangement = Arrangement.spacedBy(8.dp),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    if (isRefreshing) {
                                        CircularProgressIndicator(
                                            modifier = Modifier.size(20.dp),
                                            color = Color(0xFF1E88E5),
                                            strokeWidth = 2.dp
                                        )
                                        Text(
                                            text = "刷新中...",
                                            fontSize = 14.sp,
                                            color = Color.Gray,
                                            fontFamily = CaiFont
                                        )
                                    } else {
                                        // 显示下拉进度
                                        val progress = (pullOffset / refreshThreshold).coerceIn(0f, 1f)
                                        CircularProgressIndicator(
                                            progress = progress,
                                            modifier = Modifier.size(20.dp),
                                            color = Color(0xFF1E88E5),
                                            strokeWidth = 2.dp
                                        )
                                        Text(
                                            text = if (pullOffset >= refreshThreshold) "松开刷新" else "下拉刷新",
                                            fontSize = 14.sp,
                                            color = Color.Gray,
                                            fontFamily = CaiFont
                                        )
                                    }
                                }
                            }
                        }
                    }

                    LazyColumn(
                        state = listState,
                        contentPadding = PaddingValues(bottom = 16.dp),
                        modifier = Modifier
                            .fillMaxSize()
                            .offset(y = pullOffset.dp)
                            .windowInsetsPadding(WindowInsets.navigationBars)
                            .pointerInput(Unit) {
                                awaitPointerEventScope {
                                    while (true) {
                                        val event = awaitPointerEvent()

                                        event.changes.forEach { change ->
                                            val position = change.position
                                            val previousPosition = change.previousPosition
                                            val deltaY = position.y - previousPosition.y

                                            when {
                                                // 按下开始
                                                change.pressed && change.previousPressed.not() -> {
                                                    // 检查是否在列表顶部
                                                    val isAtTop = listState.firstVisibleItemIndex == 0 &&
                                                            listState.firstVisibleItemScrollOffset == 0
                                                    if (isAtTop && !isRefreshing) {
                                                        isDragging = true
                                                    }
                                                }
                                                // 拖动中
                                                change.pressed && isDragging -> {
                                                    if (deltaY > 0) {
                                                        // 向下拖动，增加阻力
                                                        pullOffset = (pullOffset + deltaY * dragResistance).coerceIn(0f, refreshThreshold * 1.2f)
                                                        change.consume()
                                                    } else if (pullOffset > 0) {
                                                        // 向上拖动但还有偏移
                                                        pullOffset = (pullOffset + deltaY * dragResistance).coerceAtLeast(0f)
                                                        if (pullOffset > 0) {
                                                            change.consume()
                                                        } else {
                                                            isDragging = false
                                                        }
                                                    } else {
                                                        isDragging = false
                                                    }
                                                }
                                                // 松开手
                                                !change.pressed && isDragging -> {
                                                    isDragging = false
                                                    if (pullOffset >= refreshThreshold) {
                                                        // 触发刷新
                                                        println("触发下拉刷新: pullOffset=$pullOffset")
                                                        viewModel.refresh()
                                                    } else {
                                                        // 未达到阈值，回弹
                                                        coroutineScope.launch {
                                                            while (pullOffset > 0) {
                                                                pullOffset = (pullOffset - 15f).coerceAtLeast(0f)
                                                                delay(16)
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                    ) {
                        // 3.1 轮播横幅
                        item {
                            if (uiState.banners.isNotEmpty()) {
                                BannerSection(banners = uiState.banners)
                            } else {
                                BannerSection(banners = emptyList()) // 显示默认Banner
                            }
                        }

                        // 3.1.5 排行榜横幅（已隐藏）
                        // if (isLoggedIn) {
                        //     item {
                        //         RankingBanner(
                        //             onViewMoreClick = {
                        //                 println("ECommerceHomeScreen - 点击查看更多排行榜")
                        //                 viewModel.openRanking()
                        //             }
                        //         )
                        //     }
                        // }

                        // 3.2 限时秒杀头部
                        item {
                            FlashSaleHeader()
                        }

                        // 3.3 为你推荐（所有商品）
                        if (uiState.recommendProducts.isNotEmpty()) {
                            item {
                                SectionTitle(title = "为你推荐")
                            }

                            // 商品列表（每个商品作为独立的 item）
                            // 按行分组，每行2个商品
                            val chunkedProducts = uiState.recommendProducts.chunked(2)
                            items(chunkedProducts.size) { index ->
                                val rowProducts = chunkedProducts[index]
                                Row(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .padding(horizontal = 16.dp, vertical = 4.dp),
                                    horizontalArrangement = Arrangement.spacedBy(8.dp)
                                ) {
                                    rowProducts.forEach { product ->
                                        Box(modifier = Modifier.weight(1f)) {
                                            ProductCard(
                                                product = product,
                                                onClick = { viewModel.openProductDetail(product.id) }
                                            )
                                        }
                                    }

                                    // 如果该行不满，添加空白占位
                                    repeat(2 - rowProducts.size) {
                                        Spacer(modifier = Modifier.weight(1f))
                                    }
                                }
                            }
                        } else if (!uiState.isLoading) {
                            item {
                                SectionTitle(title = "为你推荐")
                            }
                            item {
                                EmptyPlaceholder(message = "暂无推荐商品")
                            }
                        }

                        // 空状态提示（无需登录就能查看）
                        if (!uiState.isLoading && uiState.recommendProducts.isEmpty()) {
                            item {
                                EmptyState()
                            }
                        }

                        // 加载更多指示器
                        if (isLoadingMore) {
                            item {
                                Box(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .padding(16.dp),
                                    contentAlignment = Alignment.Center
                                ) {
                                    Row(
                                        horizontalArrangement = Arrangement.spacedBy(8.dp),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        CircularProgressIndicator(
                                            modifier = Modifier.size(24.dp),
                                            color = Color(0xFF1E88E5)
                                        )
                                        Text(
                                            text = "加载中...",
                                            fontSize = 14.sp,
                                            color = Color.Gray,
                                            fontFamily = CaiFont
                                        )
                                    }
                                }
                            }
                        }

                        // 没有更多数据提示
                        if (!viewModel.hasMore && uiState.recommendProducts.isNotEmpty() && !isLoadingMore) {
                            item {
                                Box(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .padding(vertical = 24.dp),
                                    contentAlignment = Alignment.Center
                                ) {
                                    Text(
                                        text = "—— 没有更多了 ——",
                                        fontSize = 14.sp,
                                        color = Color.LightGray,
                                        fontFamily = CaiFont
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }

        // 登录对话框
        if (showLoginDialog) {
            LoginDialog(
                errorMessage = uiState.error ?: "",
                onDismiss = { viewModel.hideLogin() },
                onLogin = { username, password ->
                    viewModel.performLogin(username, password)
                },
                onRegister = { phone, password, code, invitationCode ->
                    viewModel.performRegister(phone, password, code, invitationCode)
                },
                onSendCode = { phone, onSuccess, onError ->
                    viewModel.sendVerificationCode(phone, onSuccess, onError)
                }
            )
        }

        // 加载中状态
        if (uiState.isLoading) {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color.Black.copy(alpha = 0.3f)),
                contentAlignment = Alignment.Center
            ) {
                CircularProgressIndicator(color = Color.White)
            }
        }

        // 错误提示(只在未显示登录对话框时显示)
        if (!showLoginDialog) {
            uiState.error?.let { error ->
                Snackbar(
                    modifier = Modifier
                        .align(Alignment.BottomCenter)
                        .windowInsetsPadding(WindowInsets.navigationBars)
                        .padding(16.dp),
                    containerColor = Color.Red
                ) {
                    Text(text = error, color = Color.White, fontFamily = CaiFont)
                }
            }
        }

        // 网络状态提示对话框
        if (viewModel.showNetworkDialog) {
            Dialog(onDismissRequest = { viewModel.dismissNetworkDialog() }) {
                Surface(
                    shape = RoundedCornerShape(16.dp),
                    color = Color.White
                ) {
                    Column(
                        modifier = Modifier
                            .padding(24.dp)
                            .width(280.dp),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        // 标题
                        Text(
                            text = if (viewModel.isNetworkAvailable) "网络提示" else "网络异常",
                            fontSize = 18.sp,
                            fontWeight = FontWeight.Bold,
                            fontFamily = CaiFont,
                            color = if (viewModel.isNetworkAvailable) Color(0xFF4CAF50) else Color(0xFFFF5252)
                        )

                        Spacer(modifier = Modifier.height(16.dp))

                        // 消息
                        Text(
                            text = viewModel.networkMessage,
                            fontSize = 14.sp,
                            fontFamily = CaiFont,
                            color = Color.Gray,
                            textAlign = TextAlign.Center
                        )

                        Spacer(modifier = Modifier.height(20.dp))

                        // 按钮
                        Button(
                            onClick = { viewModel.dismissNetworkDialog() },
                            colors = ButtonDefaults.buttonColors(
                                containerColor = if (viewModel.isNetworkAvailable) Color(0xFF4CAF50) else Color(0xFFFF5252)
                            ),
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            Text(
                                text = "我知道了",
                                fontFamily = CaiFont
                            )
                        }
                    }
                }
            }
        }

        // 升级管理员弹框
        if (viewModel.showUpgradeAdminDialog) {
            UpgradeAdminDialog(
                onDismiss = { viewModel.closeUpgradeAdminDialog() },
                onConfirm = {
                    println("ECommerceHomeScreen - 点击确定，开始升级管理员支付")
                    viewModel.upgradeToAdmin()
                }
            )
        }

        // 升级管理员支付二维码弹框
        if (viewModel.showUpgradeAdminQrcodeDialog) {
            val qrcodeUrl = viewModel.upgradeAdminQrcodeUrl
            if (qrcodeUrl != null) {
                AlipayQrcodeDialog(
                    qrcodeUrl = qrcodeUrl,
                    orderNo = viewModel.upgradeAdminOrderNo ?: "",
                    onDismiss = {
                        viewModel.closeUpgradeAdminQrcodeDialog()
                    }
                )
            }
        }

        // 浮动按钮 - 升级管理员（只对非管理员显示）
        if (!showProfileScreen && !showProductDetail && !showOrderDetail && !showPaymentSuccess && currentUserRole != "admin") {
            FloatingActionButton(
                onClick = {
                    if (isLoggedIn) {
                        viewModel.openUpgradeAdminDialog()
                    } else {
                        viewModel.showLogin()
                    }
                },
                modifier = Modifier
                    .align(Alignment.BottomEnd)
                    .padding(16.dp)
                    .windowInsetsPadding(WindowInsets.navigationBars),
                containerColor = Color(0xFFFF6F00),
                contentColor = Color.White
            ) {
                Row(
                    modifier = Modifier.padding(horizontal = 16.dp, vertical = 12.dp),
                    horizontalArrangement = Arrangement.spacedBy(8.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Icon(
                        imageVector = Icons.Default.Star,
                        contentDescription = "升级管理员"
                    )
                    Text(
                        text = "¥99 升级",
                        fontSize = 14.sp,
                        fontWeight = FontWeight.Bold,
                        fontFamily = CaiFont
                    )
                }
            }
        }
    }
}

/**
 * 顶部标题栏（包含我的按钮）
 */
@Composable
fun TopBar(
    modifier: Modifier = Modifier,
    isLoggedIn: Boolean,
    username: String?,
    onProfileClick: () -> Unit
) {
    Surface(
        modifier = modifier.fillMaxWidth(),
        color = Color.White,
        shadowElevation = 4.dp
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 16.dp, vertical = 12.dp),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            // 左侧标题
            Text(
                text = "资源广场",
                fontSize = 20.sp,
                fontWeight = FontWeight.Bold,
                color = Color(0xFF1E88E5),
                fontFamily = CaiFont
            )

            // 右侧我的按钮
            Button(
                onClick = {
                    println("点击我的按钮") // 日志输出
                    onProfileClick()
                },
                colors = ButtonDefaults.buttonColors(
                    containerColor = Color(0xFF1E88E5)
                )
            ) {
                Icon(
                    imageVector = Icons.Default.Person,
                    contentDescription = "我的",
                    modifier = Modifier.size(18.dp)
                )
                Spacer(modifier = Modifier.width(4.dp))
                Text(
                    text = if (isLoggedIn && username != null) username else "请登录...",
                    fontFamily = CaiFont,
                    fontSize = 15.sp
                )
            }
        }
    }
}

/**
 * 登录/注册对话框
 */
@Composable
fun LoginDialog(
    errorMessage: String,
    onDismiss: () -> Unit,
    onLogin: (String, String) -> Unit,
    onRegister: (String, String, String, String?) -> Unit,
    onSendCode: (String, () -> Unit, (String) -> Unit) -> Unit
) {
    var isLoginMode by remember { mutableStateOf(true) } // true=登录, false=注册

    // 从本地存储读取记住的手机号和密码
    val savedPhone = remember { TokenManager.getRememberedPhone() ?: "" }
    val savedPassword = remember { TokenManager.getRememberedPassword() ?: "" }
    // 默认选中"记住密码"
    val savedRememberMe = remember {
        val stored = TokenManager.getRememberMe()
        // 如果之前没有保存过状态，默认为true
        if (savedPhone.isEmpty() && savedPassword.isEmpty()) true else stored
    }

    var phone by remember { mutableStateOf(savedPhone) }
    var password by remember { mutableStateOf(savedPassword) }
    var code by remember { mutableStateOf("") }
    var rememberMe by remember { mutableStateOf(savedRememberMe) }

    // 初始化邀请码：优先使用扫码保存的邀请码，没有则使用默认值
    val savedInvitationCode = TokenManager.getPendingInvitationCode()
    var invitationCode by remember { mutableStateOf(savedInvitationCode ?: "123456") }

    // 记录是否使用了扫码邀请码
    val isUsingSavedInvitationCode = remember { !savedInvitationCode.isNullOrEmpty() }

    var phoneError by remember { mutableStateOf(false) }
    var passwordError by remember { mutableStateOf(false) }
    var codeError by remember { mutableStateOf(false) }

    // 验证码倒计时状态
    var countdown by remember { mutableStateOf(0) }
    var isSendingCode by remember { mutableStateOf(false) }

    // 倒计时逻辑
    LaunchedEffect(countdown) {
        if (countdown > 0) {
            delay(1000)
            countdown--
            if (countdown % 10 == 0 || countdown <= 5) {
                println("验证码倒计时: 剩余${countdown}秒") // 日志输出
            }
        }
    }

    Dialog(onDismissRequest = onDismiss) {
        Surface(
            shape = RoundedCornerShape(16.dp),
            color = Color.White
        ) {
            Column(
                modifier = Modifier
                    .padding(24.dp)
                    .width(320.dp),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                // 标题
                Text(
                    text = if (isLoginMode) "用户登录" else "用户注册",
                    fontSize = 20.sp,
                    fontWeight = FontWeight.Bold,
                    fontFamily = CaiFont
                )

                Spacer(modifier = Modifier.height(16.dp))

                // 登录/注册切换
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.Center
                ) {
                    TextButton(
                        onClick = {
                            isLoginMode = true
                            println("切换到登录模式") // 日志输出

                            // 清空表单内容
                            println("切换到登录，清空表单内容") // 日志输出
                            phone = ""
                            password = ""
                            code = ""
                            // 保持扫码邀请码不被清除
                            if (!isUsingSavedInvitationCode) {
                                invitationCode = "123456"
                            }
                        },
                        colors = ButtonDefaults.textButtonColors(
                            contentColor = if (isLoginMode) Color(0xFF1E88E5) else Color.Gray
                        )
                    ) {
                        Text(
                            text = "登录",
                            fontSize = 16.sp,
                            fontWeight = if (isLoginMode) FontWeight.Bold else FontWeight.Normal,
                            fontFamily = CaiFont
                        )
                    }

                    Spacer(modifier = Modifier.width(24.dp))

                    TextButton(
                        onClick = {
                            isLoginMode = false
                            println("切换到注册模式") // 日志输出

                            // 清空表单内容
                            println("切换到注册，清空表单内容") // 日志输出
                            phone = ""
                            password = ""
                            code = ""
                            // 保持扫码邀请码不被清除
                            if (!isUsingSavedInvitationCode) {
                                invitationCode = "123456"
                            }
                        },
                        colors = ButtonDefaults.textButtonColors(
                            contentColor = if (!isLoginMode) Color(0xFF1E88E5) else Color.Gray
                        )
                    ) {
                        Text(
                            text = "注册",
                            fontSize = 16.sp,
                            fontWeight = if (!isLoginMode) FontWeight.Bold else FontWeight.Normal,
                            fontFamily = CaiFont
                        )
                    }
                }

                Spacer(modifier = Modifier.height(16.dp))

                // 手机号输入
                OutlinedTextField(
                    value = phone,
                    onValueChange = {
                        phone = it
                        phoneError = false
                        println("输入手机号: $it") // 日志输出
                    },
                    label = { Text("手机号", fontFamily = CaiFont) },
                    placeholder = { Text("请输入手机号", fontFamily = CaiFont) },
                    isError = phoneError,
                    modifier = Modifier.fillMaxWidth(),
                    singleLine = true,
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Phone)
                )

                if (phoneError) {
                    Text(
                        text = "请输入手机号",
                        color = Color.Red,
                        fontSize = 12.sp,
                        modifier = Modifier.align(Alignment.Start),
                        fontFamily = CaiFont
                    )
                }

                Spacer(modifier = Modifier.height(12.dp))

                // 密码输入
                var passwordVisible by remember { mutableStateOf(false) }

                OutlinedTextField(
                    value = password,
                    onValueChange = {
                        password = it
                        passwordError = false
                        println("输入密码: ${"*".repeat(it.length)}") // 日志输出（隐藏密码）
                    },
                    label = { Text("密码", fontFamily = CaiFont) },
                    placeholder = { Text("请输入密码", fontFamily = CaiFont) },
                    isError = passwordError,
                    modifier = Modifier.fillMaxWidth(),
                    singleLine = true,
                    visualTransformation = if (passwordVisible) VisualTransformation.None else PasswordVisualTransformation(),
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Password),
                    trailingIcon = {
                        IconButton(onClick = { passwordVisible = !passwordVisible }) {
                            Text(
                                text = if (passwordVisible) "👁️" else "👁️‍🗨️",
                                fontSize = 20.sp
                            )
                        }
                    }
                )

                if (passwordError) {
                    Text(
                        text = "请输入密码",
                        color = Color.Red,
                        fontSize = 12.sp,
                        modifier = Modifier.align(Alignment.Start),
                        fontFamily = CaiFont
                    )
                }

                // 记住密码选项（仅登录模式显示）
                if (isLoginMode) {
                    Spacer(modifier = Modifier.height(8.dp))
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .clickable { rememberMe = !rememberMe },
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        // 自定义复选框（使用Box模拟，兼容Web端）
                        Box(
                            modifier = Modifier
                                .size(20.dp)
                                .border(
                                    width = 2.dp,
                                    color = if (rememberMe) Color(0xFF1E88E5) else Color.Gray,
                                    shape = RoundedCornerShape(4.dp)
                                )
                                .background(
                                    color = if (rememberMe) Color(0xFF1E88E5) else Color.Transparent,
                                    shape = RoundedCornerShape(4.dp)
                                ),
                            contentAlignment = Alignment.Center
                        ) {
                            if (rememberMe) {
                                Text(
                                    text = "✓",
                                    color = Color.White,
                                    fontSize = 14.sp,
                                    fontWeight = FontWeight.Bold
                                )
                            }
                        }
                        Text(
                            text = "记住密码",
                            fontSize = 14.sp,
                            fontFamily = CaiFont,
                            modifier = Modifier.padding(start = 8.dp)
                        )
                    }
                }

                // 注册模式的额外字段
                if (!isLoginMode) {
                    Spacer(modifier = Modifier.height(12.dp))

                    // 验证码输入已隐藏，不需要验证码也能注册
                    // 注册时会使用默认验证码"000000"

                    // 邀请码输入框
                    OutlinedTextField(
                        value = invitationCode,
                        onValueChange = {
                            invitationCode = it
                            println("输入邀请码: $it") // 日志输出
                        },
                        label = { Text("邀请码（选填）", fontFamily = CaiFont) },
                        placeholder = { Text("请输入邀请码，可选", fontFamily = CaiFont) },
                        modifier = Modifier.fillMaxWidth(),
                        singleLine = true,
                        colors = OutlinedTextFieldDefaults.colors(
                            focusedBorderColor = Color(0xFF1E88E5),
                            unfocusedBorderColor = Color.Gray
                        )
                    )

                    // 邀请码说明
                    Text(
                        text = "如有邀请码可填写，没有可不填",
                        fontSize = 12.sp,
                        color = Color.Gray,
                        modifier = Modifier.padding(start = 4.dp, top = 4.dp),
                        fontFamily = CaiFont
                    )
                }

                Spacer(modifier = Modifier.height(24.dp))

                // 按钮组
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(12.dp)
                ) {
                    // 取消按钮
                    OutlinedButton(
                        onClick = {
                            println("取消${if (isLoginMode) "登录" else "注册"}") // 日志输出
                            onDismiss()
                        },
                        modifier = Modifier.weight(1f)
                    ) {
                        Text("取消", fontFamily = CaiFont)
                    }

                    // 登录/注册按钮
                    Button(
                        onClick = {
                            if (isLoginMode) {
                                // 登录验证
                                phoneError = phone.isBlank()
                                passwordError = password.isBlank()

                                if (!phoneError && !passwordError) {
                                    println("提交登录: 手机号=$phone, 记住密码=$rememberMe") // 日志输出

                                    // 保存或清除记住的密码
                                    if (rememberMe) {
                                        TokenManager.saveRememberedCredentials(phone, password)
                                        println("已保存登录凭据") // 日志输出
                                    } else {
                                        TokenManager.clearRememberedCredentials()
                                        println("已清除登录凭据") // 日志输出
                                    }

                                    onLogin(phone, password)
                                } else {
                                    println("登录验证失败") // 日志输出
                                }
                            } else {
                                // 注册验证（不需要验证码）
                                phoneError = phone.isBlank()
                                passwordError = password.isBlank()

                                if (!phoneError && !passwordError) {
                                    println("提交注册: 手机号=$phone, 邀请码=${invitationCode}") // 日志输出
                                    // 使用默认验证码"000000"
                                    val defaultCode = "000000"
                                    // 如果邀请码为空，使用默认值123456
                                    val finalInvitationCode = invitationCode.ifBlank { "123456" }
                                    onRegister(phone, password, defaultCode, finalInvitationCode)

                                    // 注册提交后保留表单内容，不清空
                                } else {
                                    println("注册验证失败") // 日志输出
                                }
                            }
                        },
                        modifier = Modifier.weight(1f),
                        colors = ButtonDefaults.buttonColors(
                            containerColor = Color(0xFF1E88E5)
                        )
                    ) {
                        Text(if (isLoginMode) "登录" else "注册", fontFamily = CaiFont)
                    }
                }

                Spacer(modifier = Modifier.height(16.dp))

                // 错误信息显示
                if (errorMessage.isNotEmpty()) {
                    Surface(
                        modifier = Modifier.fillMaxWidth(),
                        shape = RoundedCornerShape(8.dp),
                        color = Color(0xFFFFEBEE), // 浅红色背景
                        border = BorderStroke(1.dp, Color(0xFFEF5350))
                    ) {
                        Row(
                            modifier = Modifier.padding(12.dp),
                            verticalAlignment = Alignment.Top
                        ) {
                            Text(
                                text = "⚠️",
                                fontSize = 16.sp,
                                modifier = Modifier.padding(end = 8.dp)
                            )
                            Text(
                                text = errorMessage,
                                fontSize = 13.sp,
                                color = Color(0xFFD32F2F),
                                lineHeight = 18.sp,
                                fontFamily = CaiFont,
                                modifier = Modifier.weight(1f)
                            )
                        }
                    }
                }
            }
        }
    }
}

/**
 * 登录提示
 */
@Composable
fun LoginPrompt(onLoginClick: () -> Unit) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(300.dp),
        contentAlignment = Alignment.Center
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            Text(
                text = "请先登录",
                fontSize = 18.sp,
                color = Color.Gray,
                fontFamily = CaiFont
            )
            Button(
                onClick = onLoginClick,
                colors = ButtonDefaults.buttonColors(
                    containerColor = Color(0xFF1E88E5)
                )
            ) {
                Text("立即登录", fontFamily = CaiFont)
            }
        }
    }
}

/**
 * 顶部分类导航栏
 */
@Composable
fun TopCategoryNav(
    categories: List<Category>,
    selectedCategoryId: Int?,
    onCategoryClick: (Int?) -> Unit
) {
    LazyRow(
        modifier = Modifier
            .fillMaxWidth()
            .background(Color.White)
            .padding(vertical = 8.dp),
        horizontalArrangement = Arrangement.spacedBy(12.dp),
        contentPadding = PaddingValues(horizontal = 16.dp)
    ) {
        // "全部"选项
        item {
            CategoryChip(
                name = "全部",
                isSelected = selectedCategoryId == null,
                onClick = { onCategoryClick(null) }
            )
        }

        // 分类列表
        items(categories) { category ->
            CategoryChip(
                name = category.name,
                isSelected = selectedCategoryId == category.id,
                onClick = {
                    println("点击分类: ${category.name} (ID: ${category.id})") // 日志输出
                    onCategoryClick(category.id)
                }
            )
        }
    }
}

/**
 * 分类标签
 */
@Composable
fun CategoryChip(
    name: String,
    isSelected: Boolean,
    onClick: () -> Unit
) {
    Surface(
        shape = RoundedCornerShape(16.dp),
        color = if (isSelected) Color(0xFF1E88E5) else Color(0xFFE0E0E0),
        modifier = Modifier.clickable(onClick = onClick)
    ) {
        Text(
            text = name,
            fontSize = 14.sp,
            color = if (isSelected) Color.White else Color.Black,
            modifier = Modifier.padding(horizontal = 16.dp, vertical = 8.dp),
            fontFamily = CaiFont
        )
    }
}

/**
 * Banner轮播区
 */
@Composable
fun BannerSection(banners: List<Banner>) {
    if (banners.isEmpty()) {
        // 默认Banner
        DefaultBanner()
        return
    }

    // 自动轮播逻辑
    var currentIndex by remember { mutableStateOf(0) }

    // 自动切换（3秒一次）
    LaunchedEffect(banners) {
        if (banners.size > 1) {
            while (true) {
                delay(3000) // 3秒
                currentIndex = (currentIndex + 1) % banners.size
                println("Banner自动切换到: $currentIndex") // 日志输出
            }
        }
    }

    val currentBanner = banners.getOrNull(currentIndex) ?: banners.first()

    // 使用 BoxWithConstraints 根据屏幕宽度设置 Banner 高度
    BoxWithConstraints(
        modifier = Modifier
            .fillMaxWidth()
            .background(Color(0xFF1E88E5))
    ) {
        // Web平台（宽屏幕）使用500dp，移动端使用180dp
        val bannerHeight = if (maxWidth >= 600.dp) 500.dp else 180.dp
        println("BannerSection - 屏幕宽度: $maxWidth, Banner高度: $bannerHeight") // 日志输出

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(bannerHeight)
        ) {
            AsyncImage(
                model = getFullImageUrl(currentBanner.imageUrl),
                contentDescription = currentBanner.title,
                modifier = Modifier.fillMaxSize(),
                contentScale = ContentScale.Crop,
                error = rememberAsyncImagePainter(DEFAULT_IMAGE),
                placeholder = rememberAsyncImagePainter(DEFAULT_IMAGE),
                onError = {
                    println("Banner加载失败: ${getFullImageUrl(currentBanner.imageUrl)}, 显示默认图片") // 日志输出
                },
                onLoading = {
                    println("Banner加载中: ${getFullImageUrl(currentBanner.imageUrl)}") // 日志输出
                }
            )

            // Banner标题
            Box(
                modifier = Modifier
                    .align(Alignment.BottomCenter)
                    .fillMaxWidth()
                    // .background(Color.Black.copy(alpha = 0.5f))
                    .padding(16.dp)
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Text(
                        text = currentBanner.title,
                        fontSize = 18.sp,
                        fontWeight = FontWeight.Bold,
                        color = Color.White,
                        modifier = Modifier.weight(1f),
                        fontFamily = CaiFont
                    )

                    // 指示器
                    if (banners.size > 1) {
                        Row(
                            horizontalArrangement = Arrangement.spacedBy(4.dp)
                        ) {
                            banners.forEachIndexed { index, _ ->
                                Box(
                                    modifier = Modifier
                                        .size(8.dp)
                                        .background(
                                            color = if (index == currentIndex) Color.White else Color.White.copy(alpha = 0.5f),
                                            shape = RoundedCornerShape(4.dp)
                                        )
                                )
                            }
                        }
                    }
                }
            }
        }
    }
}

/**
 * 默认Banner
 */
@Composable
fun DefaultBanner() {
    // 使用 BoxWithConstraints 根据屏幕宽度设置 Banner 高度
    BoxWithConstraints(
        modifier = Modifier
            .fillMaxWidth()
            .background(Color(0xFF1E88E5)),
        contentAlignment = Alignment.Center
    ) {
        // Web平台（宽屏幕）使用500dp，移动端使用180dp
        val bannerHeight = if (maxWidth >= 600.dp) 500.dp else 180.dp
        println("DefaultBanner - 屏幕宽度: $maxWidth, Banner高度: $bannerHeight") // 日志输出

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(bannerHeight),
            contentAlignment = Alignment.Center
        ) {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Text(
                    text = "Digital Marketing",
                    fontSize = 24.sp,
                    fontWeight = FontWeight.Bold,
                    color = Color.White,
                    fontFamily = CaiFont
                )
                Text(
                    text = "超级品牌日",
                    fontSize = 16.sp,
                    color = Color.White,
                    modifier = Modifier.padding(top = 8.dp),
                    fontFamily = CaiFont
                )
            }
        }
    }
}

/**
 * 限时秒杀头部（带倍计时）
 */
@Composable
fun FlashSaleHeader() {
    // 计算距离24点的剩余时间
    var remainingSeconds by remember {
        mutableStateOf(calculateRemainingSeconds())
    }

    // 倍计时逻辑
    LaunchedEffect(Unit) {
        println("限时秒杀 - 开始倍计时，距离24点剩余时间") // 日志输出
        while (true) {
            delay(1000) // 每秒更新
            remainingSeconds = calculateRemainingSeconds()

            // 每分钟输出一次日志
            if (remainingSeconds % 60 == 0) {
                val hours = remainingSeconds / 3600
                val minutes = (remainingSeconds % 3600) / 60
                println("限时秒杀 - 距离24点剩余: ${hours}小时${minutes}分钟") // 日志输出
            }
        }
    }

    // 格式化时间显示
    val hours = remainingSeconds / 3600
    val minutes = (remainingSeconds % 3600) / 60
    val seconds = remainingSeconds % 60
    // 使用 Kotlin 字符串格式化（兼容所有平台）
    val timeText = "${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}"

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .background(Color.Red)
            .padding(horizontal = 16.dp, vertical = 12.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween
    ) {
        Text(
            text = "限时秒杀",
            color = Color.White,
            fontWeight = FontWeight.Bold,
            fontSize = 16.sp,
            fontFamily = CaiFont
        )

        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(4.dp)
        ) {
            Text(
                text = "距结束还剩：",
                color = Color.White,
                fontSize = 14.sp,
                fontFamily = CaiFont
            )

            // 时间显示（高亮背景）
            Surface(
                shape = RoundedCornerShape(4.dp),
                color = Color.White.copy(alpha = 0.3f)
            ) {
                Text(
                    text = timeText,
                    color = Color.White,
                    fontSize = 16.sp,
                    fontWeight = FontWeight.Bold,
                    modifier = Modifier.padding(horizontal = 8.dp, vertical = 4.dp),
                    fontFamily = CaiFont
                )
            }
        }
    }
}

/**
 * 区块标题
 */
@Composable
fun SectionTitle(title: String) {
    Text(
        text = title,
        fontSize = 18.sp,
        fontWeight = FontWeight.Bold,
        modifier = Modifier.padding(16.dp),
        fontFamily = CaiFont
    )
}

///**
// * 热门商品网格
// */
//@Composable
//fun HotProductsGrid(products: List<Product>) {
//    LazyVerticalGrid(
//        columns = GridCells.Fixed(2),
//        modifier = Modifier
//            .fillMaxWidth()
//            .height(600.dp), // 限制高度避免嵌套滚动问题
//        horizontalArrangement = Arrangement.spacedBy(8.dp),
//        verticalArrangement = Arrangement.spacedBy(8.dp),
//        contentPadding = PaddingValues(horizontal = 16.dp)
//    ) {
//        items(products) { product ->
//            ProductCard(product = product)
//        }
//    }
//}
/**
 * 推荐商品网格（不单独滚动，跟随页面滚动）
 * 响应式布局：根据屏幕宽度自动调整列数
 */
@Composable
fun RecommendProductsGrid(
    products: List<Product>,
    onProductClick: (Int) -> Unit
) {
    println("RecommendProductsGrid - 渲染商品网格，商品数量: ${products.size}") // 日志输出

    // 使用 BoxWithConstraints 获取屏幕宽度，动态计算列数
    BoxWithConstraints(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp)
    ) {
        // 根据屏幕宽度计算列数
        val screenWidth = maxWidth
        val columnCount = when {
            screenWidth < 600.dp -> 2  // 手机：2列
            screenWidth < 900.dp -> 3  // 平板：3列
            screenWidth < 1200.dp -> 4 // 小型桌面：4列
            else -> 5                  // 大型桌面：5列
        }

        println("RecommendProductsGrid - 屏幕宽度: $screenWidth, 列数: $columnCount") // 日志输出

        // 使用普通 Column 嵌套 Row 实现网格布局
        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            // 将商品列表按列数分组
            products.chunked(columnCount).forEach { rowProducts ->
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    rowProducts.forEach { product ->
                        Box(modifier = Modifier.weight(1f)) {
                            ProductCard(
                                product = product,
                                onClick = { onProductClick(product.id) }
                            )
                        }
                    }

                    // 如果该行不满，添加空白占位
                    repeat(columnCount - rowProducts.size) {
                        Spacer(modifier = Modifier.weight(1f))
                    }
                }
            }
        }
    }
}

/**
 * 商品卡片
 */
@Composable
fun ProductCard(
    product: Product,
    onClick: () -> Unit
) {//http://shop.aiotzq.com/image
    Card(
        modifier = Modifier
            .fillMaxWidth()
            .clickable {
                println("点击商品: ${product.name} (ID: ${product.id})") // 日志输出
                onClick()
            },
        shape = RoundedCornerShape(8.dp),
        elevation = CardDefaults.cardElevation(2.dp),
        colors = CardDefaults.cardColors(containerColor = Color.White)
    ) {
        Column(modifier = Modifier) {
            // 商品图片
            AsyncImage(
                model = getFullImageUrl(product.imageUrl),
                contentDescription = product.name,
                modifier = Modifier
                    .fillMaxWidth()
                    .height(150.dp),
                contentScale = ContentScale.Crop,
                error = coil3.compose.rememberAsyncImagePainter(DEFAULT_IMAGE),
                placeholder = coil3.compose.rememberAsyncImagePainter(DEFAULT_IMAGE),
                onError = {
                    println("商品图片加载失败: ${getFullImageUrl(product.imageUrl)}, 显示默认图片") // 日志输出
                },
                onLoading = {
                    println("商品图片加载中: ${getFullImageUrl(product.imageUrl)}") // 日志输出
                }
            )

            Spacer(modifier = Modifier.height(8.dp))
            Column(modifier = Modifier.padding(horizontal = 10.dp, vertical = 5.dp)) {
                // 商品名称
                Text(
                    text = product.name,
                    fontSize = 14.sp,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                    fontWeight = FontWeight.Medium,
                    fontFamily = CaiFont
                )

                Spacer(modifier = Modifier.height(4.dp))

                // 分类
                Text(
                    text = product.category,
                    fontSize = 12.sp,
                    color = Color.Gray,
                    fontFamily = CaiFont
                )
            }

        }
    }
}

/**
 * 空状态
 */
@Composable
fun EmptyState() {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(300.dp),
        contentAlignment = Alignment.Center
    ) {
        Text(
            text = "暂无商品",
            fontSize = 16.sp,
            color = Color.Gray,
            fontFamily = CaiFont
        )
    }
}

/**
 * 通用空数据占位组件
 */
@Composable
fun EmptyPlaceholder(message: String) {
    println("显示空数据占位: $message") // 日志输出

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(vertical = 40.dp),
        contentAlignment = Alignment.Center
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(12.dp)
        ) {
            // 空盒子图标
            Box(
                modifier = Modifier
                    .size(80.dp)
                    .background(
                        color = Color(0xFFE0E0E0),
                        shape = RoundedCornerShape(40.dp)
                    ),
                contentAlignment = Alignment.Center
            ) {
                Text(
                    text = "📦",
                    fontSize = 40.sp
                )
            }

            Text(
                text = message,
                fontSize = 16.sp,
                color = Color.Gray,
                fontFamily = CaiFont
            )

            Text(
                text = "数据加载中或暂无内容",
                fontSize = 14.sp,
                color = Color.LightGray,
                fontFamily = CaiFont
            )
        }
    }
}

/**
 * 升级管理员弹框
 */
@Composable
fun UpgradeAdminDialog(
    onDismiss: () -> Unit,
    onConfirm: () -> Unit
) {
    Dialog(onDismissRequest = onDismiss) {
        Card(
            modifier = Modifier
                .fillMaxWidth()
                .padding(16.dp),
            shape = RoundedCornerShape(16.dp),
            colors = CardDefaults.cardColors(containerColor = Color.White)
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(24.dp)
            ) {
                // 标题
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Text(
                        text = "升级管理员",
                        fontSize = 20.sp,
                        fontWeight = FontWeight.Bold,
                        fontFamily = CaiFont
                    )
                    IconButton(
                        onClick = onDismiss,
                        modifier = Modifier.size(24.dp)
                    ) {
                        Icon(
                            imageVector = Icons.Default.Close,
                            contentDescription = "关闭",
                            tint = Color.Gray
                        )
                    }
                }

                Spacer(modifier = Modifier.height(16.dp))

                // 价格信息卡片
                Card(
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(12.dp),
                    colors = CardDefaults.cardColors(
                        containerColor = Color(0xFFFFF3E0)
                    )
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(16.dp),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Text(
                            text = "仅需支付",
                            fontSize = 14.sp,
                            color = Color.Gray,
                            fontFamily = CaiFont
                        )

                        Spacer(modifier = Modifier.height(8.dp))

                        Row(
                            verticalAlignment = Alignment.Bottom
                        ) {
                            Text(
                                text = "¥",
                                fontSize = 20.sp,
                                fontWeight = FontWeight.Bold,
                                color = Color(0xFFFF6F00),
                                fontFamily = CaiFont
                            )
                            Text(
                                text = "99",
                                fontSize = 32.sp,
                                fontWeight = FontWeight.Bold,
                                color = Color(0xFFFF6F00),
                                fontFamily = CaiFont
                            )
                        }
                    }
                }

                Spacer(modifier = Modifier.height(16.dp))

                // 权益说明
                Card(
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(12.dp),
                    colors = CardDefaults.cardColors(
                        containerColor = Color(0xFFF5F5F5)
                    )
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(16.dp)
                    ) {
                        Text(
                            text = "升级权益",
                            fontSize = 16.sp,
                            fontWeight = FontWeight.Bold,
                            fontFamily = CaiFont,
                            color = Color(0xFF333333)
                        )

                        Spacer(modifier = Modifier.height(12.dp))

                        BenefitItem("🎁 获取全部资源访问权限")
                        BenefitItem("👑 享受管理员专属特权")
                        //BenefitItem("💰 邀请收益高达100%")
                        BenefitItem("⚡ 一次付费，永久有效")
                    }
                }

                Spacer(modifier = Modifier.height(24.dp))

                // 按钮区域
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(12.dp)
                ) {
                    // 返回按钮
                    OutlinedButton(
                        onClick = onDismiss,
                        modifier = Modifier
                            .weight(1f)
                            .height(48.dp),
                        shape = RoundedCornerShape(24.dp),
                        colors = ButtonDefaults.outlinedButtonColors(
                            contentColor = Color.Gray
                        )
                    ) {
                        Text(
                            text = "返回",
                            fontSize = 16.sp,
                            fontWeight = FontWeight.Medium,
                            fontFamily = CaiFont
                        )
                    }

                    // 确定按钮
                    Button(
                        onClick = onConfirm,
                        modifier = Modifier
                            .weight(1f)
                            .height(48.dp),
                        shape = RoundedCornerShape(24.dp),
                        colors = ButtonDefaults.buttonColors(
                            containerColor = Color(0xFFFF6F00)
                        )
                    ) {
                        Text(
                            text = "确定",
                            fontSize = 16.sp,
                            fontWeight = FontWeight.Bold,
                            fontFamily = CaiFont
                        )
                    }
                }
            }
        }
    }
}

/**
 * 权益条目
 */
@Composable
fun BenefitItem(text: String) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(vertical = 4.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = text,
            fontSize = 14.sp,
            fontFamily = CaiFont,
            color = Color(0xFF666666)
        )
    }
}

/**
 * 支付宝二维码弹窗（通用组件）
 */
@Composable
fun AlipayQrcodeDialog(
    qrcodeUrl: String,
    orderNo: String,
    onDismiss: () -> Unit
) {
    println("AlipayQrcodeDialog - 显示支付宝二维码: $qrcodeUrl")

    val scrollState = rememberScrollState()

    Dialog(onDismissRequest = onDismiss) {
        Card(
            modifier = Modifier
                .fillMaxWidth()
                .padding(16.dp),
            shape = RoundedCornerShape(16.dp),
            colors = CardDefaults.cardColors(containerColor = Color.White)
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .heightIn(max = 600.dp)
                    .verticalScroll(scrollState)
                    .padding(24.dp),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                // 标题和关闭按钮
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Text(
                        text = "支付宝扫码支付",
                        fontSize = 20.sp,
                        fontWeight = FontWeight.Bold,
                        fontFamily = CaiFont
                    )
                    IconButton(
                        onClick = onDismiss,
                        modifier = Modifier.size(24.dp)
                    ) {
                        Icon(
                            imageVector = Icons.Default.Close,
                            contentDescription = "关闭",
                            tint = Color.Gray
                        )
                    }
                }

                Spacer(modifier = Modifier.height(16.dp))

                Text(
                    text = "请使用支付宝扫描下方二维码完成支付",
                    fontSize = 14.sp,
                    color = Color.Gray,
                    fontFamily = CaiFont
                )

                Spacer(modifier = Modifier.height(16.dp))

                // 二维码图片
                Box(
                    modifier = Modifier
                        .size(250.dp)
                        .background(Color.White, RoundedCornerShape(12.dp))
                        .padding(16.dp),
                    contentAlignment = Alignment.Center
                ) {
                    AsyncImage(
                        model = qrcodeUrl,
                        contentDescription = "支付宝二维码",
                        modifier = Modifier.fillMaxSize(),
                        contentScale = ContentScale.Fit
                    )
                }

                Spacer(modifier = Modifier.height(12.dp))

                // 显示订单号
                Text(
                    text = "订单号: $orderNo",
                    fontSize = 12.sp,
                    color = Color.Gray,
                    fontFamily = CaiFont
                )

                Spacer(modifier = Modifier.height(16.dp))

                // 提示信息
                Text(
                    text = "支付完成后请刷新页面查看",
                    fontSize = 12.sp,
                    color = Color.Gray,
                    fontFamily = CaiFont
                )

                Spacer(modifier = Modifier.height(16.dp))

                // 关闭按钮
                OutlinedButton(
                    onClick = onDismiss,
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(8.dp)
                ) {
                    Text(
                        text = "关闭",
                        fontSize = 14.sp,
                        fontFamily = CaiFont
                    )
                }
            }
        }
    }
}

/**
 * 计算距离当天24点的剩余秒数
 * 使用跨平台TimeUtils替代kotlinx-datetime，避免Web端链接问题
 */
private fun calculateRemainingSeconds(): Int {
    // 获取当前时间戳（毫秒）
    val now = getCurrentTimeMillis()
    
    // 转换为秒，并获取今天已过的秒数
    val currentSeconds = (now / 1000) % 86400  // 86400 = 24小时的秒数
    
    // 计算距离24点的剩余秒数
    return (86400 - currentSeconds).toInt()
}